var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("planning-criteria")
            ? _c(
                "CardSimple",
                { attrs: { title: "Planning Criteria" } },
                [
                  _c("InputYearly", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "capacity_margin",
                      ]),
                      label: _vm.schema.capacity_margin.title,
                      hint: _vm.schema.capacity_margin.tooltip,
                      suffix: _vm.schema.capacity_margin.unit,
                      type: "number",
                      num_years: _vm.num_years,
                      fill: "",
                      "fill-value": _vm.schema.capacity_margin.items.default,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.capacity_margin,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "capacity_margin", $$v)
                      },
                      expression: "computedInput.capacity_margin",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "frequency_response",
                        "messages",
                      ]),
                      label: _vm.schema.frequency_response.title,
                      hint: _vm.schema.frequency_response.tooltip,
                      suffix: _vm.schema.frequency_response.unit,
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.frequency_response,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "frequency_response",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.frequency_response",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "storage_frequency_percentage",
                        "messages",
                      ]),
                      label: _vm.schema.storage_frequency_percentage.title,
                      hint: _vm.schema.storage_frequency_percentage.tooltip,
                      suffix: _vm.schema.storage_frequency_percentage.unit,
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.storage_frequency_percentage,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "storage_frequency_percentage",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.storage_frequency_percentage",
                    },
                  }),
                  _c("InputYearly", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "storage_capacity_limit",
                      ]),
                      num_years: _vm.num_years,
                      label: _vm.schema.storage_capacity_limit.title,
                      hint: _vm.schema.storage_capacity_limit.tooltip,
                      suffix: _vm.schema.storage_capacity_limit.unit,
                      type: "number",
                      fill: "",
                      "fill-value":
                        _vm.schema.storage_capacity_limit.items.default,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.storage_capacity_limit,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "storage_capacity_limit",
                          $$v
                        )
                      },
                      expression: "computedInput.storage_capacity_limit",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("scarcity-prices")
            ? _c(
                "CardSimple",
                { attrs: { title: "Scarcity Prices" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "dump_energy_cost",
                        "messages",
                      ]),
                      label: _vm.schema.storage_frequency_percentage.title,
                      hint: _vm.schema.storage_frequency_percentage.tooltip,
                      suffix: _vm.schema.storage_frequency_percentage.unit,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.dump_energy_cost,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "dump_energy_cost",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.dump_energy_cost",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "lost_load_value",
                        "messages",
                      ]),
                      label: _vm.schema.lost_load_value.title,
                      hint: _vm.schema.lost_load_value.tooltip,
                      suffix: _vm.schema.lost_load_value.unit,
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.lost_load_value,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "lost_load_value",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.lost_load_value",
                    },
                  }),
                  _vm._l(_vm.input.reserves, function (reserve, index) {
                    return _c("v-text-field", {
                      key: "reserve_" + reserve.name + index,
                      attrs: {
                        "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                          "input",
                          "reserves",
                          index,
                          "loss_value",
                          "messages",
                        ]),
                        label: "Value of Lost " + reserve.name,
                        suffix: "$/MW",
                        type: "number",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("change")
                        },
                      },
                      model: {
                        value: reserve.loss_value,
                        callback: function ($$v) {
                          _vm.$set(reserve, "loss_value", _vm._n($$v))
                        },
                        expression: "reserve.loss_value",
                      },
                    })
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "min_expost_price",
                        "messages",
                      ]),
                      label: "Minimum Ex-Post Price",
                      suffix: "$/MWh",
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.min_expost_price,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "min_expost_price",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.min_expost_price",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "max_expost_price",
                        "messages",
                      ]),
                      label: "Maximum Ex-Post Price",
                      suffix: "$/MWh",
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.max_expost_price,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "max_expost_price",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.max_expost_price",
                    },
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("reserves")
            ? _c("SystemReserve", {
                attrs: {
                  title: "Reserves",
                  "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                    "input",
                    "reserves",
                  ]),
                  reserves: _vm.input.reserves,
                  num_years: _vm.num_years,
                  popout: "",
                },
                on: {
                  "update:reserves": function ($event) {
                    return _vm.$set(_vm.input, "reserves", $event)
                  },
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("elcc-peaker-generator")
            ? _c(
                "CardSimple",
                { attrs: { title: "ELCC Peaker Generator" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.peakerSchema.source.title,
                      hint: _vm.peakerSchema.source.tooltip,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.elcc_peaker_generator.source,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput.elcc_peaker_generator,
                          "source",
                          $$v
                        )
                      },
                      expression: "computedInput.elcc_peaker_generator.source",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.peakerSchema.co2_rate.title,
                      hint: _vm.peakerSchema.co2_rate.tooltip,
                      suffix: _vm.peakerSchema.co2_rate.unit,
                      type: "number",
                      min: _vm.peakerSchema.co2_rate.minimum,
                      max: _vm.peakerSchema.co2_rate.maximum,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.elcc_peaker_generator.co2_rate,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput.elcc_peaker_generator,
                          "co2_rate",
                          _vm._n($$v)
                        )
                      },
                      expression:
                        "computedInput.elcc_peaker_generator.co2_rate",
                    },
                  }),
                  _vm.input.elcc_peaker_generator.methodology ===
                  "Net-Load relative to New Peaker"
                    ? _c("v-text-field", {
                        attrs: {
                          label: _vm.peakerSchema.derate_summer.title,
                          hint: _vm.peakerSchema.derate_summer.tooltip,
                          suffix: _vm.peakerSchema.derate_summer.unit,
                          type: "number",
                          min: _vm.peakerSchema.derate_summer.minimum,
                          max: _vm.peakerSchema.derate_summer.maximum,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value:
                            _vm.computedInput.elcc_peaker_generator
                              .derate_summer,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedInput.elcc_peaker_generator,
                              "derate_summer",
                              _vm._n($$v)
                            )
                          },
                          expression:
                            "computedInput.elcc_peaker_generator.derate_summer",
                        },
                      })
                    : _vm._e(),
                  _vm.input.elcc_peaker_generator.methodology ===
                  "Net-Load relative to New Peaker"
                    ? _c("v-text-field", {
                        attrs: {
                          label: _vm.peakerSchema.derate_winter.title,
                          hint: _vm.peakerSchema.derate_winter.tooltip,
                          suffix: _vm.peakerSchema.derate_winter.unit,
                          type: "number",
                          min: _vm.peakerSchema.derate_winter.minimum,
                          max: _vm.peakerSchema.derate_winter.maximum,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value:
                            _vm.computedInput.elcc_peaker_generator
                              .derate_winter,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedInput.elcc_peaker_generator,
                              "derate_winter",
                              _vm._n($$v)
                            )
                          },
                          expression:
                            "computedInput.elcc_peaker_generator.derate_winter",
                        },
                      })
                    : _vm._e(),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.peakerSchema.fom.title,
                      hint: _vm.peakerSchema.fom.tooltip,
                      suffix: _vm.peakerSchema.fom.unit,
                      type: "number",
                      min: _vm.peakerSchema.fom.minimum,
                      max: _vm.peakerSchema.fom.maximum,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.elcc_peaker_generator.fom,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput.elcc_peaker_generator,
                          "fom",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.elcc_peaker_generator.fom",
                    },
                  }),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              label: _vm.peakerSchema.fuel_unit.title,
                              items: _vm.peakerSchema.fuel_unit.enum,
                              hint: _vm.peakerSchema.fuel_unit.tooltip,
                              "persistent-hint": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedInput.elcc_peaker_generator
                                  .fuel_unit,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedInput.elcc_peaker_generator,
                                  "fuel_unit",
                                  $$v
                                )
                              },
                              expression:
                                "computedInput.elcc_peaker_generator.fuel_unit",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-switch", {
                            attrs: {
                              label: _vm.peakerSchema.profile_fuel_price.title,
                              hint: _vm.peakerSchema.profile_fuel_price.tooltip,
                              "persistent-hint": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedInput.elcc_peaker_generator
                                  .profile_fuel_price,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedInput.elcc_peaker_generator,
                                  "profile_fuel_price",
                                  $$v
                                )
                              },
                              expression:
                                "computedInput.elcc_peaker_generator.profile_fuel_price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.input.elcc_peaker_generator.profile_fuel_price
                    ? _c("InputYearly", {
                        attrs: {
                          label: _vm.peakerSchema.fuel_price.title,
                          hint: _vm.peakerSchema.fuel_price.tooltip,
                          suffix: _vm.input.elcc_peaker_generator.fuel_unit,
                          num_years: _vm.num_years,
                          fill: "",
                          "fill-value":
                            _vm.peakerSchema.fuel_price.items.default,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value:
                            _vm.computedInput.elcc_peaker_generator.fuel_price,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedInput.elcc_peaker_generator,
                              "fuel_price",
                              $$v
                            )
                          },
                          expression:
                            "computedInput.elcc_peaker_generator.fuel_price",
                        },
                      })
                    : _c("InputYearlyProfile", {
                        attrs: {
                          label: _vm.peakerSchema.fuel_price_profiles.title,
                          hint: _vm.peakerSchema.fuel_price_profiles.tooltip,
                          num_years: _vm.num_years,
                          suffix: _vm.input.elcc_peaker_generator.fuel_unit,
                          "profile-type":
                            _vm.peakerSchema.fuel_price_profiles.profileType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value:
                            _vm.computedInput.elcc_peaker_generator
                              .fuel_price_profiles,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedInput.elcc_peaker_generator,
                              "fuel_price_profiles",
                              $$v
                            )
                          },
                          expression:
                            "computedInput.elcc_peaker_generator.fuel_price_profiles",
                        },
                      }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.peakerSchema.heat_rate.title,
                      hint: _vm.peakerSchema.heat_rate.tooltip,
                      suffix: _vm.peakerSchema.heat_rate.unit,
                      type: "number",
                      min: _vm.peakerSchema.heat_rate.minimum,
                      max: _vm.peakerSchema.heat_rate.maximum,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.elcc_peaker_generator.heat_rate,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput.elcc_peaker_generator,
                          "heat_rate",
                          _vm._n($$v)
                        )
                      },
                      expression:
                        "computedInput.elcc_peaker_generator.heat_rate",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.peakerSchema.ramp_rate.title,
                      hint: _vm.peakerSchema.ramp_rate.tooltip,
                      suffix: _vm.peakerSchema.ramp_rate.unit,
                      type: "number",
                      min: _vm.peakerSchema.ramp_rate.minimum,
                      max: _vm.peakerSchema.ramp_rate.maximum,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.elcc_peaker_generator.ramp_rate,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput.elcc_peaker_generator,
                          "ramp_rate",
                          _vm._n($$v)
                        )
                      },
                      expression:
                        "computedInput.elcc_peaker_generator.ramp_rate",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.peakerSchema.vom.title,
                      hint: _vm.peakerSchema.vom.tooltip,
                      suffix: _vm.peakerSchema.vom.unit,
                      type: "number",
                      min: _vm.peakerSchema.vom.minimum,
                      max: _vm.peakerSchema.vom.maximum,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.elcc_peaker_generator.vom,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput.elcc_peaker_generator,
                          "vom",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.elcc_peaker_generator.vom",
                    },
                  }),
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c("v-card-title", [
                        _c("h6", { staticClass: "text-h6" }, [
                          _vm._v("Peaker Reserves"),
                        ]),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c("InputReserve", {
                            attrs: {
                              label: _vm.peakerSchema.reserves.title,
                              hint: _vm.peakerSchema.reserves.tooltip,
                              reserves: _vm.input.reserves,
                              suffix: _vm.peakerSchema.reserves.unit,
                              type: "number",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedInput.elcc_peaker_generator
                                  .reserves,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedInput.elcc_peaker_generator,
                                  "reserves",
                                  $$v
                                )
                              },
                              expression:
                                "computedInput.elcc_peaker_generator.reserves",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }